import React, { useState, useMemo, useRef } from "react";
import { Grid, FormControl, Input, InputLabel, Select, MenuItem, Button, makeStyles, Hidden } from "@material-ui/core";
import { debounce } from '../utils/debounce';
import DatePicker from './DatePicker';

const useStyles = makeStyles((theme) => ({
    paddRight: {
        [theme.breakpoints.up('sm')]: {
            paddingRight: theme.spacing(3),
        },
    },
    paddBottom: {
       paddingBottom: theme.spacing(3),
    },
    resetButtonStyles: {
        marginTop: '16px',
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
        },
    }
}));

function Form({state, setState, constants}) {
    const classes = useStyles();
    const [searchText, setSearchText] = useState(state.searchString);
    const formEl = useRef(null);

    const handler = useMemo(() => debounce(val => setState({ ...state, pageIndex: 0, searchString: val }), 500), [state, setState]);

    const onSearchChange = event => {
        const value = event.target.value;

        setSearchText(value);
        handler(value);
    };

    const handleReset = () => {
        setState({
            ...state,
            pageIndex: 0,
            searchString: '',
            startDate: constants.initialStartDate,
            endDate: constants.initialEndDate,
            category: 'all',
            source: 'all',
        });

        setSearchText('');
    }

    return (
        <form ref={formEl}>
            <Grid container className={classes.paddBottom}>
                <Grid container item xs={12}>
                    <Grid className={classes.paddBottom} item xs={12} sm={4}>
                        <FormControl className={classes.paddRight} fullWidth>
                            <InputLabel htmlFor="search">Search</InputLabel>
                            <Input id="search" value={searchText} onChange={e => onSearchChange(e)} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl className={classes.paddRight} fullWidth>
                            <InputLabel id="select-label">Category</InputLabel>
                            <Select labelId="select-label" id="select" value={state.category} onChange={e => setState({ ...state, pageIndex: 0, category: e.target.value })}>
                                <MenuItem key="all" value="all">All</MenuItem>
                                {constants.initialCategories.map((obj, i) => (
                                    <MenuItem key={i} value={i}>{obj.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid container item xs={12}>
                    <Grid item xs={12} sm={8}>
                        <Hidden only="xs">
                            <DatePicker state={state} setState={setState} constants={constants} formEl={formEl} />
                        </Hidden>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button className={classes.resetButtonStyles} onClick={ handleReset } variant="contained">Reset</Button>
                    </Grid>
                </Grid>

            </Grid>
        </form>
    );
}

export default Form;
